import { Component, forwardRef, HostBinding, Input, Output, EventEmitter, OnInit, ViewEncapsulation } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { UtilsService } from '@library/utils/services/utils.service';

@Component({
  selector: 'el-slider-picker',
  templateUrl: './slider-picker.component.html',
  styleUrls: ['./slider-picker.component.sass'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SliderPickerComponent),
      multi: true
    }
  ]
})
export class SliderPickerComponent implements ControlValueAccessor, OnInit {

  @HostBinding('class') class = 'is-fullwidth is-flex is-direction-column';

  /**
   * Label of the input
   */
  @Input() name = '';

  /*
    * Icon of the input
  */
  @Input() icon = '';

  /**
   * Input value
   */
  @Input() input: number;
  @Output() inputChange = new EventEmitter<number>();

  /**
   * Min, max and step of the slider.
   * If it's a time slider, put these values in minutes.
   */
  @Input() min: number;
  @Input() max: number;
  @Input() step: number;
  /**
   * timeValueDelimeter used to insert special character in value for time
   */
  @Input() timeValueDelimeter = ':';

  /**
   * valueUnit used to insert unit for value at end of value string
   */
  @Input() valueUnit = '';

  /**
   * Determines the type of the slider.
   * Changes the displayed value accordingly.
   */
  @Input() type: string;

  @Input() hasText = true;

  /**
   * Value, min and max of the slider to display
   */
  displayValue: number | string;
  displayMin: number | string;
  displayMax: number | string;

  @Input() minLabel: string;
  @Input() maxLabel: string;

  @Input() legend = null;


  constructor(
    private utilsService: UtilsService,
  ) {}

  ngOnInit() {
    switch (this.type) {
      case 'time': {
        this.displayMin = this.utilsService.numberToTime(this.min, this.timeValueDelimeter);
        this.displayMax = this.utilsService.numberToTime(this.max, this.timeValueDelimeter);
        break;
      }
      case 'label': {
        this.displayMax = this.maxLabel;
        this.displayMin = this.minLabel;
        break;
      }
      default: {
          this.displayMin = this.min + this.valueUnit;
          this.displayMax = this.max + this.valueUnit;
          break;
      }
    }
  }

  propagateChange: any = () => {};

  writeValue(value) {
    if (value !== undefined) {
      this.input = value;
      switch (this.type) {
        case 'time': {
          this.displayValue = this.utilsService.numberToTime(value, this.timeValueDelimeter);
          break;
        }
        case 'label': {
          break;
        }
        default: {
          this.displayValue = value + this.valueUnit;
        }
      }
    }
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  // Unused but necessary to implement ControlValueAccessor
  registerOnTouched() {}

  changeValue(event): void {
    switch (this.type) {
      case 'time': {
        this.displayValue = this.utilsService.numberToTime(this.input, this.timeValueDelimeter);
        this.displayMin = this.utilsService.numberToTime(this.min, this.timeValueDelimeter);
        this.displayMax = this.utilsService.numberToTime(this.max, this.timeValueDelimeter);
        break;
      }
      case 'label': {
        break;
      }
      default: {
        this.displayValue = this.input + this.valueUnit;
        this.displayMin = this.min + this.valueUnit;
        this.displayMax = this.max + this.valueUnit;
        break;
      }
    }
    this.inputChange.emit(event);
    this.propagateChange(event);
  }

  getText() {
    return typeof this.displayValue === 'undefined' ? '' : this.displayValue.toString();
  }
}

/**
 * Used in Settings Legrand, Settings Energy V2
 */
